'use strict';

angular.module('magview')
  .controller('BuildLogCtrl', [
    '$scope', 'BuildLogViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel();
    }
  ]);
